import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import GeneralButtonsChoiceSegmentButton from 'lumen/components/general/buttons/choice-segment-button';
import type { Method } from 'lumen/components/settings/budget-forecast/modal-bulk-update';

interface SettingsBudgetForecastModalBulkUpdateMethodSelectionSignature {
  Args: {
    method: Method;
    setMethod: (method: Method) => void;
    view: 'budget' | 'forecast';
  };
}

const SettingsBudgetForecastModalBulkUpdateMethodSelection = <template>
  <div class="flex flex-col gap-500">
    <p class="text-300--medium">
      {{if
        (eq @view "budget")
        (t "budget_forecast.budget.bulk_update.description")
        (t "budget_forecast.forecast.bulk_update.description")
      }}
    </p>

    <div class="flex gap-500">
      <GeneralButtonsChoiceSegmentButton
        @isChecked={{eq @method "fill-from-existing"}}
        @label={{t "budget_forecast.bulk_update.fill_from_existing"}}
        @onClick={{fn @setMethod "fill-from-existing"}}
        @type="radio"
      />

      <GeneralButtonsChoiceSegmentButton
        @isChecked={{eq @method "custom-bulk-edit"}}
        @label={{t "budget_forecast.bulk_update.custom_bulk_edit"}}
        @onClick={{fn @setMethod "custom-bulk-edit"}}
        @type="radio"
      />
    </div>
  </div>
</template> satisfies TOC<SettingsBudgetForecastModalBulkUpdateMethodSelectionSignature>;

export default SettingsBudgetForecastModalBulkUpdateMethodSelection;
